import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { ADVANCED_PLANS_APP_STEPS, APP_STEPS } from 'stores/App.store';
import { HeaderNavStepper } from '@wix/wix-ui-premium-purchase';
import { Text, Box, Tooltip } from '@wix/design-system';
import s from './AppHeader.scss';
import { Template } from 'enums';
import {
  withExperiments,
  InjectedExperimentsProps,
} from '@wix/wix-experiments-react';
import { RootStore, withInjectedRootStore } from 'providers';
import classNames from 'classnames';

interface LoggedinHeaderStepsProps extends InjectedExperimentsProps {
  rootStore: RootStore;
  currentStep: number;
  changeStep(step: number): void;
}

const LoggedinHeaderStepsComp: React.FC<LoggedinHeaderStepsProps> = ({
  rootStore,
  currentStep,
  changeStep,
}) => {
  const { t } = useTranslation();
  const { isDowngradePlanOfDeclineChargeService } = rootStore.appStore;
  const { template } = usePageModeContext();
  const steps =
    template === Template.Grid ? ADVANCED_PLANS_APP_STEPS : APP_STEPS;
  const isDisabled = (index) =>
    index > currentStep ||
    (isDowngradePlanOfDeclineChargeService && index === 1 && currentStep === 2);

  const WrapWithTooltip: React.FC<{ index: number }> = ({
    children,
    index,
  }) => {
    return isDowngradePlanOfDeclineChargeService && index === 1 ? (
      <Tooltip
        content={t(
          'change_plan.change_declined_plan_feature.step_header_tooltip',
        )}
        disabled={false}
      >
        {children}
      </Tooltip>
    ) : (
      <>{children}</>
    );
  };

  return (
    <Box
      dataHook='loggedin-header-steps'
      className={classNames({
        [s.hideCheckmark]: isDowngradePlanOfDeclineChargeService,
      })}
    >
      <HeaderNavStepper
        data-hook='nav-stepper'
        activeStep={currentStep}
        onStepClick={changeStep}
        fontUpgrade={true}
      >
        {steps.map((stepTitle, index) => (
          <HeaderNavStepper.Step
            key={stepTitle}
            data-hook='nav-step'
            disabled={isDisabled(index)}
            data-is-disabled={isDisabled(index)}
          >
            <WrapWithTooltip index={index}>
              <Text size='small' className={s.stepText}>
                {t(stepTitle)}
              </Text>
            </WrapWithTooltip>
          </HeaderNavStepper.Step>
        ))}
      </HeaderNavStepper>
    </Box>
  );
};

export const LoggedinHeaderSteps = withInjectedRootStore(
  withExperiments(LoggedinHeaderStepsComp),
);
